import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { ContactsParams } from "@/api/types"

export const mailContactsPrefixKey = ["contacts"] as const

export function mailContactsOptions(params: ContactsParams = {}) {
	return queryOptions({
		queryKey: [...mailContactsPrefixKey, params] as const,
		queryFn: () => GET("/api/v1/contacts", { params: { query: params } }),
		placeholderData: keepPreviousData,
	})
}

export function useMailContacts(params: ContactsParams = {}) {
	return useQuery(mailContactsOptions(params))
}

export function useContactCompanies() {
	return useQuery({
		queryKey: [...mailContactsPrefixKey, "companies"],
		queryFn: () => GET("/api/v1/contacts/companies"),
	})
}
